import { render } from "./PricesTaskForm.vue?vue&type=template&id=6f21d930&scoped=true"
import script from "./PricesTaskForm.vue?vue&type=script&lang=js"
export * from "./PricesTaskForm.vue?vue&type=script&lang=js"

import "./PricesTaskForm.vue?vue&type=style&index=0&id=6f21d930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f21d930"]])

export default __exports__